import { Avatar, AvatarMobile, AvatarProps } from '@kizi/comparator-components';
import {
  ComponentDescriptor,
  getRendererFromDescriptor,
} from '@kizi/comparator-core';
import { Div, DivProps, Heading, P, Svg } from '@kizi/core-components';
import React from 'react';

export interface CommentWithAvatarProps extends DivProps {
  avatar: AvatarProps;
  comment: React.ReactNode;
  commentTitle: React.ReactNode;
  isLoading?: boolean;
  mobile?: boolean;
}

export const CommentWithAvatar: React.FC<CommentWithAvatarProps> = ({
  avatar,
  comment,
  commentTitle,
  isLoading,
  children,
  mobile = true,
  ...divProps
}) => {
  const [loadingTitle, setLoadingTitle] = React.useState('Een momentje');
  React.useEffect(() => {
    let interval;
    if (isLoading) {
      interval = setInterval(() => {
        setLoadingTitle((title) => {
          if (title.endsWith('...')) {
            return title.replace('...', '');
          }
          return `${title}.`;
        });
      }, 500);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isLoading, setLoadingTitle]);
  return (
    <Div
      display={[mobile ? 'flex' : 'none', 'flex']}
      alignItems={['flex-end', 'stretch']}
      {...divProps}
    >
      <Avatar mr={[2, 4]} display={['none', 'none', 'block']} {...avatar} />
      <Div position="relative" ml={[0, 0, 4]}>
        <Svg
          display={['none', 'none', 'block']}
          filter="drop-shadow(0px -5px 3px rgba(0, 0, 0, 0.1))"
          height={29}
          left={-30}
          position="absolute"
          style={{
            transform: 'rotate(-90deg)',
          }}
          top={6}
          viewBox="0 0 27 17"
          width={39}
          zIndex={1}
        >
          <path
            d="M10.1846 1.9125L0 17.0008H27L16.8154 1.9125C15.2295 -0.436976 11.7705 -0.436981 10.1846 1.9125Z"
            fill="white"
          />
        </Svg>
        <Div flexGrow={2} variant="primaryCard">
          <Heading mb={[1, 2]} mt={0} as="h4" variant="H4">
            {isLoading ? loadingTitle : commentTitle}
          </Heading>
          <P variant="bodyRegularToCaption">
            {isLoading
              ? 'Wij zoeken de best passende verzekeringen voor je uit'
              : comment}
          </P>
          <Div display={['flex', 'flex', 'none']} justifyContent={'flex-end'}>
            <AvatarMobile {...avatar} />
          </Div>
          {children}
        </Div>
      </Div>
    </Div>
  );
};

export interface CommentWithAvatarWrapperProps extends CommentWithAvatarProps {
  children: ComponentDescriptor;
}

export const CommentWithAvatarWrapper: React.FC<
  CommentWithAvatarWrapperProps
> = ({ children, ...restProps }) => {
  return (
    <CommentWithAvatar {...restProps}>
      {getRendererFromDescriptor(children)}
    </CommentWithAvatar>
  );
};
